import { Card, Checkbox, Flex, Skeleton, Tooltip, Typography } from 'antd';

interface AnalyticsInfoCardProps {
  title: string;
  isLegend: boolean;
  value?: string;
  currency?: string;
  checkedValue?: boolean;
  list?: {
    title: string;
    value: string;
  }[];
  tooltipDescription?: string;
  onChange?: (checked: boolean) => void;
  isMetric?: boolean;
  loading: boolean;
  notTransaction: boolean;
}

export const AnalyticsInfoCard = ({
  title,
  value,
  isLegend,
  currency,
  checkedValue,
  onChange,
  list,
  tooltipDescription,
  isMetric,
  loading,
  notTransaction,
}: AnalyticsInfoCardProps) => {
  return (
    <Tooltip
      title={
        tooltipDescription ? (
          <Flex
            vertical
            gap={2}
          >
            <Typography.Text className="info-card-tooltip-title">{title}</Typography.Text>
            <Typography.Text className="info-card-tooltip-description">{tooltipDescription}</Typography.Text>
          </Flex>
        ) : null
      }
      classNames={{ root: 'custom-tooltip info-card-tooltip' }}
      placement="top"
      color="#6A6A6A"
    >
      <Card
        title={title}
        extra={
          isLegend && !notTransaction ? (
            <Checkbox
              className="info-card-checkbox"
              checked={checkedValue}
              onChange={(e) => onChange?.(e.target.checked)}
              disabled={loading}
            />
          ) : undefined
        }
        className={`info-card ${checkedValue ? 'checked-legend' : ''} ${!isLegend ? 'info-bg' : ''} ${isMetric ? 'metric-card' : ''} ${
          notTransaction ? 'disabled' : ''
        }`}
      >
        <Flex
          className="info-card-value-area"
          align="flex-end"
          gap={4}
        >
          {list && list.length > 0 ? (
            <Flex
              vertical
              gap={4}
              className="w-100"
            >
              {list?.map((item) => (
                <Flex justify="space-between">
                  <Typography.Text className="info-card-body-list-title">{item.title}</Typography.Text>
                  <Typography.Text className="info-card-body-list-value">
                    {loading ? (
                      <Skeleton.Input
                        className="info-card-body-list-value-skeleton"
                        active
                      />
                    ) : (
                      <>
                        {item.value}
                        {currency && <Typography.Text className="info-card-currency-list">{currency}</Typography.Text>}
                      </>
                    )}
                  </Typography.Text>
                </Flex>
              ))}
            </Flex>
          ) : (
            <>
              <Typography.Text className="info-card-value">
                {loading ? (
                  <Skeleton.Input
                    className="info-card-value-skeleton"
                    active
                  />
                ) : (
                  value
                )}
              </Typography.Text>
              {currency && <Typography.Text className="info-card-currency">{currency}</Typography.Text>}
            </>
          )}
        </Flex>
      </Card>
    </Tooltip>
  );
};
